function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Buttongroup, Button } from '../';
import "./AuthOptions.scss";

class AuthOptions extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "onChange", value => {
      if (this.props.onChange) {
        this.props.onChange(value);
      }
    });

    _defineProperty(this, "renderOption", (option, index) => {
      const label = option.label,
            value = option.value;
      return React.createElement(Button, _extends({}, option, {
        type: "auth-option",
        selected: this.props.value === value,
        onClick: () => this.onChange(value)
      }));
    });
  }

  render() {
    const options = this.props.options;

    if (!options) {
      return false;
    }

    return React.createElement(Buttongroup, {
      type: "auth-options"
    }, options.map(this.renderOption));
  }

}

_defineProperty(AuthOptions, "defaultProps", {
  options: undefined,
  value: undefined
});

export default AuthOptions;